import { Fragment } from 'react';
import {
    Datagrid,
    DateField,
    DateInput,
    TextField,
    EmailField,
    TextInput,
    Filter,
    BulkDeleteButton,
    BulkExportButton,
    BooleanField,
    BooleanInput,
} from 'react-admin';
import { List, ListActions } from '@react-admin/ra-enterprise';
import { CustomBreadcrumb } from './CustomBreadcrumb';
import CustomPagination from './CustomPagination';
import { makeStyles } from '@material-ui/core/styles';
import EarnCommissionLink from './EarnCommissionLink';
import UserLink from './UserLink';


function idRoleAllow(resource_name, action_name) {
    let return_value = 'no';
    let login_role = localStorage.getItem('role');
    if (login_role == 'admin') {
        return 'ok';
    }
    let allpermission = JSON.parse(localStorage.getItem("roles"));
    let roledata = [];
    if (login_role == 'accountant') {
        roledata = allpermission.accountant;
    }
    if (login_role == 'auditor') {
        roledata = allpermission.auditor;
    }
    if (login_role == 'editor') {
        roledata = allpermission.editor;
    }
    roledata.map((role_row, index) => {
        if ((role_row.resource == resource_name) && (role_row.action.indexOf(action_name) > -1)) {
            console.log('operation ok');
            return_value = 'ok';
        }
    });
    return return_value;
}
const EarnCommissionBulkActionButtons = ({ basePath }) => (
    <Fragment>
        {(idRoleAllow('earncommission', 'export') == 'ok') ?
            <BulkExportButton /> : ''}
        {(idRoleAllow('earncommission', 'delete') == 'ok') ?
            <BulkDeleteButton basePath={basePath} /> : ''}
    </Fragment>
);

const EarnCommissionActions = (props) => (
    <ListActions  {...props} breadcrumb={<CustomBreadcrumb variant="actions" />} exporter={(idRoleAllow('earncommission', 'export') == 'ok') ? true : false} />
)

const EarnCommissionFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Transaction Id" source="sourced_orders_id" defaultValue="" />
        <TextInput label="Referrer Id" source="affiliate_receiver" defaultValue="" />
        <DateInput label="Paid since" source="created_at" defaultValue="" />
        <DateInput label="Paid before" source="updated_at" defaultValue="" />
    </Filter>
);

const newStyle = makeStyles({
    tdcolor: { color: '#4f3cc9' }
});

const EarnCommission = (props) => {
    const classes = newStyle();
    return (
        <List
            {...props}
            sort={{ field: 'created_at', order: 'DESC' }}
            actions={<EarnCommissionActions />}
            filters={<EarnCommissionFilter />}
            bulkActionButtons={<EarnCommissionBulkActionButtons />}
            pagination={<CustomPagination />}
            title="Earn commission"            
        >
            <Datagrid>
                <EarnCommissionLink source="sourced_orders_id" label="Transaction Id" />
                <UserLink source="referrer_id" label="Referrer Id" />
                <TextField source="affiliate_receiver" label="Referral Id" />
                <TextField source="exchangepair" label="Markets" />
                <TextField source="received_fund" label="Amount" />
                <TextField source="commission_rate" label="Commission" />
                <TextField source="affiliates_rates" label="Received" />
                <DateField source="created_at" label="Paid at" showTime />
                <BooleanField source="status" label="Status" />
            </Datagrid>
        </List>
    )
};
export default EarnCommission;